export enum FilterNames {
  TYPE = 'types',
  SITE = 'sites',
}
